export default "__VITE_ASSET__X1Ri$b_Q__"